import { useMemo } from 'react'

const BASE_CHECKOUT_URL =
  'https://kreanacrochet.com/cart/add?id=52757072314479&quantity=1'

export function useCheckoutUrl(): string {
  return useMemo(() => {
    const currentParams = window.location.search
    if (!currentParams || currentParams === '?') return BASE_CHECKOUT_URL

    // Remove the leading "?" and append with "&" since base URL already has query params
    const utmParams = currentParams.startsWith('?')
      ? currentParams.slice(1)
      : currentParams
    if (!utmParams) return BASE_CHECKOUT_URL

    return `${BASE_CHECKOUT_URL}&${utmParams}`
  }, [])
}
